import { useContext } from 'react';

import { Feature } from 'config/features';
import { FeatureContext } from 'context/FeatureContext';

/**
 * get state of given features
 */
export const useFeatureList = (...features: Feature[]) => {
    const featureMap = useContext(FeatureContext);

    return features.map((name) => featureMap[name] ?? false);
};

/**
 * check if any of given features is active
 */
export const useAnyFeature = (...features: Feature[]) => {
    const featureMap = useContext(FeatureContext);

    return features.some((name) => featureMap[name] ?? false);
};
/**
 * check if all given features are active
 */
export const useEveryFeature = (...features: Feature[]) => {
    const featureMap = useContext(FeatureContext);

    return features.every((name) => featureMap[name] ?? false);
};
/**
 * check if given feature is active
 */
export const useFeature = (name: Feature) => {
    const featureMap = useContext(FeatureContext);

    return featureMap[name] ?? false;
};
